
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1yxqk_103",
  "button": "awsui_button_vjswe_1yxqk_107",
  "variant-normal": "awsui_variant-normal_vjswe_1yxqk_158",
  "variant-icon": "awsui_variant-icon_vjswe_1yxqk_201",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1yxqk_201",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1yxqk_201",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1yxqk_222",
  "disabled": "awsui_disabled_vjswe_1yxqk_243",
  "variant-primary": "awsui_variant-primary_vjswe_1yxqk_251",
  "variant-link": "awsui_variant-link_vjswe_1yxqk_344",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1yxqk_623",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1yxqk_906",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1yxqk_1004",
  "button-no-text": "awsui_button-no-text_vjswe_1yxqk_1097",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1yxqk_1101",
  "full-width": "awsui_full-width_vjswe_1yxqk_1104",
  "icon-left": "awsui_icon-left_vjswe_1yxqk_1123",
  "icon-right": "awsui_icon-right_vjswe_1yxqk_1128",
  "icon": "awsui_icon_vjswe_1yxqk_1123"
};
  